export const AMO_API_URL = `${process.env.BASE_URL}/v1`;

export const MODAL_NAMES = {
  document: 'document',
  start: 'start',
  navigation: 'navigation',
};

export const DOCUMENT_MODAL_TYPES = {
  agreement: 'agreement',
  security: 'security',
  confidence: 'confidence',
};

export const JS_CLASS_NAMES = {
  withPreventScrollOffset: 'js-scroll-preventable',
  withPreventScrollTouch: 'js-scroll-touch',
};

export const DOCUMENT_URL_PARAM_KEY = 'document';

export const URLS = {
  cases: 'https://www.amocrm.ru/cases',
  amostart: 'https://amostart.ru/',
  apiDocks: 'https://www.amocrm.ru/developers/content/crm_platform/platform-abilities',
};
